export const ERROR_TYPE = {
    FAILURE: 'FAILURE',
    INVALID_DATE: 'INVALID_DATE',
    CHECKIN_EXCEEDS_CHECKOUT: 'CHECKIN_EXCEEDS_CHECKOUT',
    CHECKIN_NOT_AVAILABLE: 'CHECKIN_NOT_AVAILABLE',
    CHECKOUT_NOT_AVAILABLE: 'CHECKOUT_NOT_AVAILABLE',
}

export const ERROR_STATE_MAP = {
    FAILURE: {
        title: 'Whoops!',
        subTitle: 'We are seeing overwhelming traffic. Please try again in sometime.',
        buttonText: 'Try again',
        onButtonClick: () => (window.location.href = '/hotels'),
        errorType: ERROR_TYPE.FAILURE,
    },
    INVALID_DATE: {
        title: 'Looks like your dates are in the the past',
        subTitle: 'Please search again with different dates',
        buttonText: 'Home',
        onButtonClick: () => (window.location.href = '/hotels'),
        errorType: ERROR_TYPE.INVALID_DATE,
    },
    CHECKIN_EXCEEDS_CHECKOUT: {
        title: 'Your checkin date cannot be after your checkout date',
        subTitle: '',
        buttonText: 'Home',
        onButtonClick: () => (window.location.href = '/hotels'),
        errorType: ERROR_TYPE.CHECKIN_EXCEEDS_CHECKOUT
    },
    CHECKIN_NOT_AVAILABLE: {
        title: 'Checkin date is not available',
        subTitle: '',
        buttonText: 'Home',
        onButtonClick: () => (window.location.href = '/hotels'),
        errorType: ERROR_TYPE.CHECKIN_NOT_AVAILABLE
    },
    CHECKOUT_NOT_AVAILABLE: {
        title: 'Checkout date is not available',
        subTitle: '',
        buttonText: 'Home',
        onButtonClick: () => (window.location.href = '/hotels'),
        errorType: ERROR_TYPE.CHECKOUT_NOT_AVAILABLE
    }
}